// extracted by mini-css-extract-plugin
export default {"wrapper":"landscapeOverlay__wrapper__ySlEt","phoneIcon":"landscapeOverlay__phoneIcon__hXNeF","phoneRotate":"landscapeOverlay__phoneRotate__NBry2"};